import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import CustomTableForXlsx from "../../components/customTable/CustomTableForXlsx";
import { createMRTColumnHelper } from "material-react-table";
import { redeem_orderApi } from "../../app/slices/redeemSlice";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy } from "@mui/icons-material";

import dayjs from "dayjs";
import Swal from "sweetalert2";
import axios from "axios";
// import { Grid, width } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";
import axiosInstance from "../../utils/axiosInstance";

export default function RedeemResponse() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  // console.log("queryParams: ", queryParams);
  // const [startDate, setStartDate] = useState(dayjs().format("YYYY-MM-DD"));

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(redeem_orderApi(queryParams));
  // }, [dispatch, queryParams]);

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    metalType: "",

    name: "",
    orderId: "",

    // transactionId: "",
    merchantTransactionId: "",
    // pgorderId:"",
    customerRefNo: "",
  });

  const url = `/api/admin/augmont-redeem/list`;

  const {
    handleFilterSubmit,
    handleClearFilters,
    loader,
    results,
    apiCall,
    message,
    error,
    toastTrigger,
  } = useFilterHandler(url, filterData, setFilterData);

  // console.log("tufani bhaiya---------------------->",results)
  useEffect(() => {
    apiCall(false);
  }, []);

  useEffect(() => {
    if (!message) return;

    console.log("Message updated:", message);

    if (error) {
      toast.error(message);
    }
    //  else {
    //   // toast.success(message);
    // }
  }, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.redeem_order.redeem_order.data,
  );
  const stateLoading = useSelector((state) => state.redeem_order.loading);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo || "N/A"}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("customerName", {
      header: "Name",
      size: 100,
      Cell: (cell) => cell.row.original?.customerName,
    }),

    columnHelper.accessor("mobileNumber", {
      header: "Phone",
      size: 100,
      Cell: (cell) => cell.row.original?.mobileNumber,
    }),

    // columnHelper.accessor("message", {
    //   header: "Message",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.message,
    // }),

    columnHelper.accessor("redeemWeight", {
      header: "Weight",
      size: 100,
      Cell: (cell) => cell.row.original?.redeemWeight,
    }),
    // columnHelper.accessor("status", {
    //   header: "Status",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.status,
    // }),

    // columnHelper.accessor("awbNo", {
    //   header: "awbNo",
    //   size: 200,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?.awbNo);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?.awbNo}>
    //         <span>
    //           <IconButton onClick={handleCopy}>
    //             <ContentCopy />
    //           </IconButton>
    //           {cell.row.original?.awbNo}
    //         </span>
    //       </Tooltip>
    //     );
    //   },
    // }),
    // columnHelper.accessor("logisticName", {
    //   header: "Logistic Name",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.logisticName,
    // }),

    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 100,
      Cell: (cell) => cell.row.original?.metalType,
    }),

    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 100,
      Cell: (cell) => cell.row.original?.quantity,
    }),
    // columnHelper.accessor("goldBalance", {
    //   header: "Gold Balance",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.goldBalance,
    // }),
    // columnHelper.accessor("silverBalance", {
    //   header: "Silver Balance",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.silverBalance,
    // }),
    columnHelper.accessor("shippingCharges", {
      header: "Shipping Charges",
      size: 100,
      Cell: (cell) => cell.row.original?.shippingCharges,
    }),

    // columnHelper.accessor("statusCode", {
    //   header: "Status Code",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.statusCode,
    // }),
    // columnHelper.accessor("message", {
    //   header: "Message",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.message,
    // }),

    // Status
    // columnHelper.accessor("is_deleted", {
    //   header: "Is Deleted",
    //   size: 100,
    //   Cell: (cell) => (cell.row.original?.is_deleted ? "Yes" : "No"),
    // }),

    columnHelper.accessor("partner_id", {
      header: "Partner Id",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.partner_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.partner_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.partner_id}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 100,
      Cell: (cell) => cell.row.original?.partner_username,
    }),

    columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(
            cell.row.original?.merchantTransactionId,
          );
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("orderId", {
      header: "Order ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.orderId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.orderId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.orderId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("payment_id", {
      header: "Payment ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.payment_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.payment_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.payment_id}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("pgOrder_id", {
      header: "PGOrder ID",
      size: 150,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.pgOrder_id);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.pgOrder_id}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.pgOrder_id}
            </span>
          </Tooltip>
        );
      },
    }),
    // Timestamps
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
    columnHelper.accessor("Action", {
      header: "Action",
      size: 150,
      Cell: (cell) => (
        <Button
          onClick={() => {
            handleViewStatus(cell.row.original);
            setOpen(true);
          }}
          variant="contained"
        >
          View Status
        </Button>
      ),
    }),
  ];

  const filteredDataForExcelExport = sliceResponse?.map((item) => ({
    "Customer Ref No": item.customerRefNo,
    "Customer Name": item.customerName,
    Amount: item.shippingCharges,
    "Merchant Transaction ID": item.merchantTransactionId,
    "Partner Username": item.partner_username,
    Date: `${item.createdAt?.split("T")[0]} ${
      item.createdAt?.split("T")[1].split("+")[0]
    } `,
    "Payment ID": item.payment_id,
    "Order ID": item.order_id,
    Refinery: "Augmont",
  }));
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");

  const [selectedRow, setSelectedRow] = useState(null);
  // console.log("selectedRow: ", selectedRow);
  const handleViewStatus = async (row) => {
    try {
      const url = `/augmont_redeem_info`;
      // const url = `${baseUrl}/augmont_redeem_info`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(
        url,
        {
          customerRefNo: row.customerRefNo,
          merchantTransactionId: row.merchantTransactionId,
        },
        // { headers }
      );
      // const response = await axios.post(
      //   url,
      //   {
      //     customerRefNo: row.customerRefNo,
      //     merchantTransactionId: row.merchantTransactionId,
      //   },
      //   { headers }
      // );
      setSelectedRow(response?.data?.data[0]?.result?.data);
      console.log("response.data.data: ", response.data.data);
    } catch (error) {
      console.error("Error updating user:", error);
      Swal.fire({
        // text: response.data.message,
        text: "Something went wrong",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* <DateSearchComponent onSearch={handleSearch} /> */}
      <Filter
        filterData={filterData}
        onFilterSubmit={handleFilterSubmit}
        Onclear={handleClearFilters}
        page={"augmont_redeem"}
        setFilterData={setFilterData}
      />
      <Box mt={2}>
        {/* <CustomTable columns={columns} data={sliceResponse} loading={stateLoading} /> */}
        {loader ? (
          <Loader />
        ) : (
          <CustomTableForXlsx
            columns={columns}
            data={results}
            loading={loader}
            date={dayjs(filterData.startDate).format("DD-MM-YYYY")}
            filteredData={results}
            permissionKey="Redeems"
          />
        )}
      </Box>

      {/* <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            // border: "2px solid #000",
            boxShadow: 24,
            p: 1,
          }}
        >
          <Tooltip title="Close">
            <IconButton
              sx={{ float: "right" }}
              onClick={() => {
                handleClose(false);
              }}
              aria-label="delete"
              size="small"
            >
              <CloseIcon
                fontSize="inherit"
                color="error"
                sx={{ color: "red" }}
              />
            </IconButton>
          </Tooltip>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item xs={6} fontWeight="bold">
                Status:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.status}
              </Grid>

              <Grid item xs={6} fontWeight="bold">
                AWB No:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.awbNo}{" "}
              </Grid>

              <Grid item xs={6} fontWeight="bold">
                Logistic Name:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.logisticName}
              </Grid>

              <Grid item xs={6} fontWeight="bold">
                Merchant Order ID:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.merchantOrderId}
              </Grid>

              <Grid item xs={6} fontWeight="bold">
                Transaction ID:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.transactionId}
              </Grid>

              <Grid item xs={6} fontWeight="bold">
                Unique ID:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.uniqueId}
              </Grid>
              <Grid item xs={6} fontWeight="bold">
                Invoice No
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.invoiceNo}
              </Grid>
              <Grid item xs={6} fontWeight="bold">
                Shipping Charges:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.shippingCharges}
              </Grid>
              <Grid item xs={6} fontWeight="bold">
                Mode Of Payment:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.modeOfPayment}
              </Grid>
              <Grid item xs={6} fontWeight="bold">
                Last Updated:
              </Grid>
              <Grid item xs={6}>
                {selectedRow?.updatedAt?.split("T")[0]}
              </Grid>
              <Divider item xs={6} fontWeight="bold"></Divider>
            </Grid>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                fontWeight: "bold",
                borderBottom: 1,
                borderRadius: 1,
                mt: 2,
              }}
            >
              Shipping Address
            </Typography>
            <Grid container spacing={2} sx={{ mt: 3 }}>
              <Grid item md={6} xs={6} fontWeight="bold">
                Name:
              </Grid>
              <Grid item md={6} xs={6}>
                {selectedRow?.shippingAddress?.name}
              </Grid>
              <Grid item md={6} xs={6} fontWeight="bold">
                Mobile:
              </Grid>
              <Grid item md={6} xs={6}>
                {selectedRow?.shippingAddress?.mobile}
              </Grid>
              <Grid item md={6} xs={6} fontWeight="bold">
                Pin Code:
              </Grid>
              <Grid item md={6} xs={6}>
                {selectedRow?.shippingAddress?.pincode}
              </Grid>
              <Grid item md={6} xs={6} fontWeight="bold">
                Address:
              </Grid>
              <Grid item md={6} xs={6}>
                {selectedRow?.shippingAddress?.address}
              </Grid>
              <Grid item md={6} xs={6} fontWeight="bold">
                city:
              </Grid>
              <Grid item md={6} xs={6}>
                {selectedRow?.shippingAddress?.city}
              </Grid>
              <Grid item md={6} xs={6} fontWeight="bold">
                state:
              </Grid>
              <Grid item md={6} xs={6}>
                {selectedRow?.shippingAddress?.state}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal> */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <strong style={{ fontSize: 18 }}>Augmont Redeem Details</strong>
          <Tooltip title="Close">
            <IconButton
              sx={{ float: "right" }}
              onClick={() => {
                handleClose(false);
              }}
              aria-label="delete"
              size="small"
            >
              <CloseIcon
                fontSize="inherit"
                color="error"
                sx={{ color: "red" }}
              />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent dividers>
          {selectedRow ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Row 1 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Status:</strong> {selectedRow?.status}{" "}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>AWB No:</strong> {selectedRow?.awbNo}{" "}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Logistic Name:</strong> {selectedRow?.logisticName}
                  </Typography>
                </Box>
              </Box>
              {/* Row 2 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Merchant Order ID:</strong>{" "}
                    {selectedRow?.transactionId}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Unique ID:</strong> {selectedRow?.uniqueId}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Invoice No</strong> {selectedRow?.invoiceNo}
                  </Typography>
                </Box>
              </Box>

              {/* Row 3 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Shipping Charges:</strong>{" "}
                    {selectedRow?.shippingCharges}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Mode Of Payment:</strong>{" "}
                    {selectedRow?.modeOfPayment}{" "}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Last Updated:</strong>{" "}
                    {selectedRow?.updatedAt?.split("T")[0]}
                  </Typography>
                </Box>
              </Box>

              {/* Row 9 */}
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: 1,
                  borderRadius: 1,
                  mt: 2,
                }}
              >
                Shipping Address
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Name:</strong> {selectedRow?.shippingAddress?.name}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Mobile:</strong>{" "}
                    {selectedRow?.shippingAddress?.mobile}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>Pin Code:</strong>{" "}
                    {selectedRow?.shippingAddress?.pincode}
                  </Typography>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong>state:</strong>{" "}
                    {selectedRow?.shippingAddress?.state}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 2,
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> city:</strong> {selectedRow?.shippingAddress?.city}
                  </Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body1">
                    <strong> Address:</strong>{" "}
                    {selectedRow?.shippingAddress?.address}
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  borderBottom: 1,
                  borderRadius: 1,
                  mt: 2,
                }}
              >
                Product Details
              </Typography>

              {/* Row 10 */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 0,
                }}
              >
                <Box sx={{ width: "80%" }}>
                  <Box
                    sx={{
                      // flex: 1,
                      display: "flex",
                      // justifyContent: "space-evenly",
                      // justifyContent: "space-between",
                      gap: 0,
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body1">
                        <strong>Product Name:</strong>{" "}
                        {selectedRow?.productDetails[0]?.productName}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 0,
                      mt: 3,
                    }}
                  >
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body1">
                        <strong>Price:</strong>{" "}
                        {selectedRow?.productDetails[0]?.price}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body1">
                        <strong>Quantity:</strong>{" "}
                        {selectedRow?.productDetails[0]?.quantity}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body1">
                        <strong>metalType:</strong>{" "}
                        {selectedRow?.productDetails[0]?.metalType}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="body1">
                        <strong>sku:</strong>{" "}
                        {selectedRow?.productDetails[0]?.sku}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                <Box sx={{ flex: 1, width: "20%" }}>
                  <Typography variant="body1">
                    <strong>Product Image:</strong>{" "}
                    <img
                      src={
                        selectedRow?.productDetails[0]?.productImages[0]?.url
                      }
                      alt=""
                      height={100}
                      width={100}
                    />
                  </Typography>
                </Box>
              </Box>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                  backgroundColor: "background.default",
                }}
              >
                <CircularProgress size={80} sx={{ color: "#1976d2" }} />
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
